import { inject, Injectable, Injector } from '@angular/core'; // <-- Добавили Injector
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { GlobalErrorDisplayService } from '../services';

@Injectable()
export class GlobalErrorHandlerHttpInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          const errorDisplayService = this.injector.get(GlobalErrorDisplayService);

          errorDisplayService.display(err);
        }

        return throwError(() => err.message);
      })
    );
  }
}
